document.addEventListener("DOMContentLoaded", () => {
  function initShowMore(buttonClass, listClass) {
    const button = document.querySelector(`.${buttonClass}`);
    const list = document.querySelector(`.${listClass}`);
    if (!button || !list) {
      return;
    }

    // Отримуємо значення атрибута lang з елемента <html>
    const currentLang = document.documentElement.lang;

    // Функція для оновлення тексту кнопки
    function updateButtonText() {
      let buttonText, hideText;

      if (currentLang === "en" || currentLang === "en-US") {
        buttonText = "Read more";
        hideText = "Hide";
      } else if (currentLang === "ru-RU") {
        buttonText = "Читать больше";
        hideText = "Скрыть";
      } else {
        buttonText = "Читати більше";
        hideText = "Сховати";
      }

      // Оновлюємо текст на кнопці
      button.querySelector("span").textContent = list.classList.contains("show")
        ? hideText
        : buttonText;
    }

    updateButtonText();

    button.addEventListener("click", () => {
      if (list.classList.contains("show")) {
        list.style.maxHeight = null;
        list.classList.remove("show");
      } else {
        list.style.maxHeight = list.scrollHeight + "px";
        list.classList.add("show");
      }
      updateButtonText();
    });
  }

  // Виклик функції

  initShowMore("advantages-btn", "advantages-list-hidden");
});
